export default __webpack_public_path__ + "static/media/icon-bills.13b02be1.svg";